"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormGroup = _interopRequireDefault(require("./FormGroup"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormInputModule = _interopRequireDefault(require("./FormInput.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var FormInputResizableTextArea = /*#__PURE__*/function (_React$Component) {
  _inherits(FormInputResizableTextArea, _React$Component);

  var _super = _createSuper(FormInputResizableTextArea);

  function FormInputResizableTextArea(props) {
    var _this;

    _classCallCheck(this, FormInputResizableTextArea);

    _this = _super.call(this, props);
    _this.state = {
      value: _this.props.value,
      rows: _this.props.minRows,
      minRows: _this.props.minRows,
      maxRows: _this.props.maxRows
    };
    return _this;
  }

  _createClass(FormInputResizableTextArea, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      if (this.props.skip) {
        return null;
      }

      var errorMessage = null;

      if (this.props.errors) {
        errorMessage = this.props.errors[this.props.name];
      }

      var inputClasses = (0, _classnames["default"])((_classNames = {
        "form-control": true
      }, _defineProperty(_classNames, _FormInputModule["default"].invalidDisabled, true), _defineProperty(_classNames, "textarea", true), _classNames));

      var handleChange = function handleChange(event) {
        var previousRows = event.target.rows;
        event.target.rows = _this2.props.minRows; // reset number of rows in textarea

        var currentRows = ~~(event.target.scrollHeight / _this2.props.textareaLineHeight);

        if (currentRows === previousRows) {
          event.target.rows = currentRows;
        }

        if (currentRows >= _this2.props.maxRows) {
          event.target.rows = _this2.props.maxRows;
          event.target.scrollTop = event.target.scrollHeight;
        }

        _this2.setState({
          value: event.target.value,
          rows: currentRows < _this2.props.maxRows ? currentRows : _this2.props.maxRows
        });

        _this2.props.onChange(event);
      };

      return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        hasError: !!errorMessage,
        filled: !!this.props.value
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "bmd-label-floating",
        htmlFor: this.props.name
      }, errorMessage || this.props.label), /*#__PURE__*/_react["default"].createElement("textarea", _extends({}, this.props.attrs, {
        className: inputClasses,
        id: this.props.name,
        name: this.props.name,
        rows: this.state.rows,
        value: this.state.value || "",
        ref: this.props.innerRef,
        onBlur: this.props.onBlur,
        onKeyPress: this.props.onKeyPress,
        onChange: handleChange
      })));
    }
  }]);

  return FormInputResizableTextArea;
}(_react["default"].Component);

FormInputResizableTextArea.propTypes = {
  errors: _propTypes["default"].object,
  value: _propTypes["default"].any.isRequired,
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  innerRef: _propTypes["default"].object,
  onBlur: _propTypes["default"].func,
  onKeyPress: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  skip: _propTypes["default"].bool,
  type: _propTypes["default"].string.isRequired,
  textareaLineHeight: _propTypes["default"].number,
  minRows: _propTypes["default"].number,
  maxRows: _propTypes["default"].number
};
FormInputResizableTextArea.defaultProps = {
  value: "",
  textareaLineHeight: 24,
  minRows: 1,
  maxRows: 5
};
var _default = FormInputResizableTextArea;
exports["default"] = _default;